<template>
  <div class="column" :class="columnSize">
    <b-field
      :label="label"
      horizontal
      :type="active ? 'is-info' : ''"
      :custom-class="active ? 'has-text-info' : ''"
    >
      <b-input
        :name="name"
        size="is-small"
        :value="value"
        :disabled="disabled"
        @input="onInput"
      />
    </b-field>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String
    },
    value: {
      type: String
    },
    name: {
      type: String
    },
    active: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    columnSize: {
      type: Object | String,
      default: "is-12"
    }
  },
  methods: {
    onInput(value) {
      this.$emit("input", value);
      this.$emit("update:value", value);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/OrderFilter/Field/OrderFilterFieldInput.vue